
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CalendarDays, Clock, MessageSquare } from "lucide-react";
import { format } from 'date-fns';
import { ScheduleAssistantResponse, DateTimeRange } from '@/types/calendar';

interface SuggestionsDisplayProps {
  suggestions: ScheduleAssistantResponse;
  onSchedule: (timeSlot: DateTimeRange) => void;
}

const SuggestionsDisplay: React.FC<SuggestionsDisplayProps> = ({
  suggestions,
  onSchedule
}) => {
  return (
    <Card className="border-primary/20">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary"><circle cx="12" cy="12" r="9"/><path d="M14.5 11.5c.28.57.5 1.33.5 2a5 5 0 0 1-10 0v-2a3 3 0 0 1 6 0v.5"/><path d="M8.5 11.5a2.5 2.5 0 0 1 5 0v.5"/></svg>
          AI Scheduling Suggestions
        </CardTitle>
        <CardDescription>{suggestions.message}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {suggestions.suggestedTimeSlots.map((slot, index) => (
            <div key={index} className="flex justify-between items-center p-3 border rounded-lg hover:bg-muted/50">
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2">
                  <CalendarDays className="h-4 w-4 text-primary" />
                  <span className="font-medium">{format(slot.start, 'EEEE, MMMM d')}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Clock className="h-3 w-3" />
                  <span>
                    {format(slot.start, 'h:mm a')} - {format(slot.end, 'h:mm a')}
                  </span>
                </div>
              </div>
              <Button
                size="sm"
                onClick={() => onSchedule(slot)}
              >
                Schedule
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter className="border-t px-6 py-4 bg-muted/30">
        <div className="flex items-start gap-2 w-full">
          <MessageSquare className="h-4 w-4 text-muted-foreground mt-0.5" />
          <div className="text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-1">AI Reasoning:</p>
            <p>{suggestions.reasoning}</p>
          </div>
        </div>
      </CardFooter>
    </Card>
  );
};

export default SuggestionsDisplay;
